export default "__VITE_ASSET__BXlhKKuf__"